var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mp4-player"},[_c('div',{staticClass:"mp4-wrapper cursor-p",on:{"click":_vm.playVideo}},[_c('SvgIcon',{staticClass:"icon-video",attrs:{"icon-class":"icon-shipin"}}),_c('div',[_vm._v(_vm._s(_vm.$t('playVideo')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }